export enum WhoInvoices {
    TENANT,
    ADMIN,
}
